import React from "react";
import { Link } from "react-router-dom";
import { Rocket as RocketIcon } from "lucide-react";
import FavHeart from "./FavHeart";
import ShareButton from "./ShareButton";

export default function RocketCard({ rocket }) {
  const { id, full_name, name, family, variant, reusable, image_url, manufacturer } = rocket;
  const displayName = full_name || name;
  const familyName = family?.name || family || (typeof family === "string" ? family : "");
  const status = reusable ? "REUSABLE" : "EXPENDABLE";
  const mfg = manufacturer?.name || "—";
  return (
    <Link to={`/fleet/${id}`} data-testid={`rocket-card-${id}`}
      className="sat-surface sat-brackets group block relative transition-all hover:sat-box-glow">
      <div className="h-40 bg-black overflow-hidden relative">
        {image_url ? (
          <img src={image_url} alt={displayName} loading="lazy" className="w-full h-full object-contain opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
        ) : (
          <div className="w-full h-full flex items-center justify-center"><RocketIcon size={44} className="text-[color:var(--sat-border-bright)]"/></div>
        )}
        <div className="absolute top-2 left-2 border border-[color:var(--sat-cyan)] px-2 py-1 sat-label sat-cyan bg-black/60">
          {status}
        </div>
      </div>
      <div className="p-4 flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <span className="sat-label sat-cyan">{typeof familyName === "string" ? familyName.toUpperCase() : "FAMILY"}</span>
          <div className="flex items-center gap-1.5">
            <ShareButton url={`${window.location.origin}/fleet/${id}`} title={displayName} size={11} testid={`rocket-share-${id}`} />
            <FavHeart kind="rocket" ref_id={id} title={displayName} image={image_url} payload={{ family: familyName }} size={12} />
          </div>
        </div>
        <h3 className="font-display font-bold text-lg leading-tight group-hover:text-[color:var(--sat-cyan)] transition-colors">
          {displayName}
        </h3>
        <p className="text-xs text-[color:var(--sat-text-dim)] font-mono truncate">{mfg}</p>
        {variant && <div className="sat-label">VARIANT · {variant}</div>}
      </div>
    </Link>
  );
}
